import React from "react";
import Announcement from "../../Parts/Ecossistema/Announcement";
export default function Ecossistema() {
  return (
    <div id="ecossistema">
      <Announcement />
    </div>
  );
}
